import { Grid, styled } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import PropTypes from "prop-types";
import { colors, layout } from "../theme";

export const drawerWidth = layout.sidebar;
export const collapsedDrawerWidth = layout.sidebarRail;
export const appBarHeight = layout.topbar;

// The expanded sidebar overlays the page, so the app bar only clears the rail.
export const AppBar = ({ mobile, children }) => {
  const left = mobile ? 0 : collapsedDrawerWidth;

  return (
    <Grid
      component="header"
      container
      alignItems="center"
      justifyContent="space-between"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        left,
        zIndex: 1200,
        width: `calc(100% - ${left}px)`,
        height: appBarHeight,
        padding: "0 22px",
        backgroundColor: colors.surface,
        borderBottom: `1px solid ${colors.border}`,
        boxShadow: "0 1px 2px rgba(18, 24, 36, 0.03)",
      }}
    >
      {children}
    </Grid>
  );
};

AppBar.propTypes = {
  mobile: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export const BottomAppBar = ({ open, children }) => {
  const left = open ? drawerWidth : collapsedDrawerWidth;

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      style={{
        position: "fixed",
        right: 0,
        bottom: 0,
        left,
        zIndex: 1200,
        width: `calc(100% - ${left}px)`,
        height: 48,
        backgroundColor: colors.primaryDeep,
        color: colors.textOnBrand,
      }}
    >
      {children}
    </Grid>
  );
};

BottomAppBar.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export const DrawerHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: appBarHeight,
  height: appBarHeight,
  padding: "0 14px 0 18px",
  borderBottom: `1px solid ${colors.border}`,
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "expanded" && prop !== "mobile",
})(({ theme, expanded, mobile }) => {
  const width = expanded ? drawerWidth : collapsedDrawerWidth;

  return {
    // Only the rail takes up layout space; the expanded paper overlays the page.
    width: mobile ? 0 : collapsedDrawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    "& .MuiDrawer-paper": {
      zIndex: theme.zIndex.drawer + 1,
      width: mobile ? drawerWidth : width,
      overflowX: "hidden",
      backgroundColor: colors.surface,
      color: colors.text,
      borderRight: `1px solid ${colors.border}`,
      boxShadow: expanded && !mobile ? "var(--shadow-medium)" : "none",
      transition: theme.transitions.create(["width", "box-shadow"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.short,
      }),
    },
  };
});
